module.exports = __webpack_public_path__ + "img/shop_panel_PVC.d309989d.jpg";